import React from 'react';
import { Props } from './CaseListingItem.types';
import styles from './CaseListingItem.module.scss';

const CaseListingItem: React.FC<Props> = ({ caseItem, onItemClick, onTaskCounterClick }) => {
  const taskNotification = caseItem.todoTasksCount > 1 ? 'new tasks' : 'new task';
  return (
    <div className={styles.item} onClick={onItemClick}>
      <div className={styles.wrapper}>
        <div className={styles.details}>
          <p className={styles.title}>{caseItem.fullnames.join(' & ')}</p>
          <p className={styles.meta}>
            <span>{caseItem.caseId}</span>
            <span className={styles.textDivider}>&#9679;</span>
            <span>Updated: {caseItem.updatedAt}</span>
          </p>
        </div>
        <div className={styles.additionalDetails}>
          {caseItem.todoTasksCount > 0 && (
            <div className={styles.taskNotificationBox} onClick={onTaskCounterClick}>
              <span className={styles.taskNotification}>
                {caseItem.todoTasksCount} {taskNotification}
              </span>
            </div>
          )}
          {caseItem.isOnHoldStatus && <span className={styles.status}>Hold</span>}
          <span className={styles.status}>{caseItem.status}</span>
        </div>
      </div>
    </div>
  );
};

export default CaseListingItem;
